<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import { ElMessage } from "element-plus";
import axios from "axios";

export default {
  data() {
    return {
      news_tab: 1,
      width: document.innerWidth,
      // news: [
      //   {
      //     id: 1,
      //     title: "外媒：乌总统公布最新伤亡字数",
      //     img: require("../assets/kekon.png"),
      //     date: "02-02",
      //     content:
      //       "【俄乌开战第二日最新局势图】财联社2月25日电，俄罗斯与乌克兰武装冲突昨日正式开始后，开战已超过24小时。",
      //   },
      //   {
      //     id: 2,
      //     title: "外媒：乌总统公布最新伤亡字数",
      //     img: require("../assets/kekon.png"),
      //     date: "02-03",
      //     content:
      //       "【俄乌开战第二日最新局势图】财联社2月25日电，俄罗斯与乌克兰武装冲突昨日正式开始后，开战已超过24小时。",
      //   },
      //   {
      //     id: 3,
      //     title: "外媒：乌总统公布最新伤亡字数",
      //     img: require("../assets/kekon.png"),
      //     date: "02-04",
      //     content:
      //       "【俄乌开战第二日最新局势图】财联社2月25日电，俄罗斯与乌克兰武装冲突昨日正式开始后，开战已超过24小时。",
      //   },
      // ],
      inner_width: 1024,
      case_forWidth: 400,
      cases: [],
      caseItem: {},
      hascase: false,
      content: "",
      vision: "",
      isKK: true,
      name: "",
      aboutURL: "",
    };
  },
  computed: {},
  mounted() {
    this.inner_width = document.querySelector(".inner").offsetWidth;
    new Swiper(".swiper-container", {
      autoplay: 3000, //可选项，自动滑动
      pagination: ".swiper-pagination",
      height: 300,
      lazyLoading: true,
      lazyLoadingInPrevNext: true,
      loop: true,
      effect: "fade",
      fade: {
        crossFade: false,
      },
    });
    this.queryCase();
    this.case_forWidth = this.hascase
      ? document.querySelector(".case_for").offsetWidth
      : 400;
    const host = window.location.host;
    this.isKK = host.includes("fjkkauto");
    //  this.isKK = true;
    this.content = this.isKK
      ? " 福建科控自动化科技有限公司成立于2012年，立足东南科创热土，深耕工业数智蓝海，福建科控科技十余年来始终锚定工业企业数字化智能化转型赛道，以技术为笔、以服务为墨，绘就工业升级新蓝图。自成立以来，我们始终坚守诚信、创新、专业的核心价值观：以诚信为立业之基，对客户坦诚相待、对品质坚守承诺；以创新为发展引擎，持续深耕人工智能、工业自动化、大数据云计算等前沿技术领域；以专业为服务底色，沉淀十余年行业实践经验，打磨过硬的技术服务团队。我们具备雄厚的研发实力，深厚的行业知识沉淀，构建了覆盖自动化、数字化的全场景完整解决方案矩阵，已帮助数十家工业企业完成数智化升级改造，实现降本增效的发展目标。"
      : "北京凯创通达科技有限公司成立于2017年，坐落于北京副中心CBD中央商务区。是一家从事工业自动化产品销售、设计研发，系统集成、并提供一站式设备解决方案为一体的现代化科技创新企业。公司由一群具有丰富行业经验的专业人士创立，旨在通过技术创新和优质服务，成为自动化和智慧工厂领域的领导者。";
    this.vision = this.isKK ? "科控科技" : "凯创通达";
    this.name = this.isKK ? "福建科控自动化科技有限公司" : "北京凯创通达科技有限公司";
    this.aboutURL = this.isKK
      ? require("../assets/kkabout.png")
      : require("../assets/bjkc.png");
  },
  methods: {
    newstab: function (index) {
      //点击后打开新闻详情页面并传递ID
      this.news_tab = index;
      this.news = [
        {
          id: 1,
          title: (index == 1 ? "公司-" : "行业-") + "境外：乌总统公布最新伤亡字数",
          img: require("../assets/kekon.png"),
          date: "02-02",
          content:
            "【俄乌开战第二日最新局势图】财联社2月25日电，俄罗斯与乌克兰武装冲突昨日正式开始后，开战已超过24小时。",
        },
        {
          id: 2,
          title: "行业：乌总统公布最新伤亡字数",
          img: require("../assets/kekon.png"),
          date: "02-03",
          content:
            "【俄乌开战第二日最新局势图】财联社2月25日电，俄罗斯与乌克兰武装冲突昨日正式开始后，开战已超过24小时。",
        },
        {
          id: 3,
          title: "行业：乌总统公布最新伤亡字数",
          img: require("../assets/kekon.png"),
          date: "02-04",
          content:
            "【俄乌开战第二日最新局势图】财联社2月25日电，俄罗斯与乌克兰武装冲突昨日正式开始后，开战已超过24小时。",
        },
      ];
      this.$forceUpdate();
    },
    opennews: (id) => {
      //跳转到新闻详情界面并带上ID
      alert(id);
    },
    doRouter() {
      this.$router.push("/ServicePage");
    },
    digRou() {
      this.$router.push("/DigitizePage");
    },
    routerTeam() {
      this.$router.push("/TeamPage");
    },
    queryCase() {
      axios
        .get("/case/query", {
          params: { status: 1 },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            // ElMessage.success("数据获取成功");
            this.cases = response.data.data;
            this.hascase = this.cases.length > 0;
            this.caseItem = response.data.data[0];
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("数据获取失败：", error);
        });
    },
    doCar(item) {
      this.caseItem = item;
    },
    routerCasePage() {
      this.$router.push("/CasePage");
    },
  },
};
</script>
<template>
  <div>
    <div>
      <div class="banner">
        <div class="banner_item">
          <video autoplay muted loop>
            <source v-if="this.isKK" src="../assets/13.mp4" type="video/mp4" />
            <source v-else src="../assets/bjlogo.mp4" type="video/mp4" />
          </video>
          <!-- <img class="shouye" src="../assets/bigbei.gif" /> -->
          <div class="banner_wen">
            <div class="banner_title">致力于工业4.0智能制造</div>
            <div class="banner_content">
              以智慧制作为奋斗目标，工业自动化技术为先导，加上物联网技术应用，结合大数据，云计算，人工智能等信息技术，推动工业智能制造，产业智能升级。
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="news">
        <div class="inner">
          <div class="title">
            <span class="line"></span>
            <span>新闻资讯</span>
            <span class="sub_title">/News</span>
          </div>
          <div class="pannel">
            <div class="tabs flex">
              <div class="flex-item">
                <div
                  class="tab_item"
                  @click="newstab(1)"
                  :class="{ tab_item_active: news_tab == 1 }"
                >
                  <div>公司新闻</div>
                </div>
                <div
                  class="tab_item"
                  @click="newstab(2)"
                  :class="{ tab_item_active: news_tab == 2 }"
                >
                  <div>行业新闻</div>
                </div>
              </div>
              <div class="more_btn_pannel">
                <span class="more_btn">MORE</span>
              </div>
            </div>
            <div class="tabitems flex">
              <div
                class="new_box"
                v-for="(item, index) in news"
                :style="{ width: inner_width / 3 - 1 + 'px' }"
                :key="item.id"
              >
                <div v-if="index != 0" class="news_item_split"></div>
                <div
                  class="item"
                  :style="{
                    width:
                      inner_width / 3 -
                      (index == 0 || index == news.length - 1 ? 15 : 30) -
                      60 +
                      'px',
                  }"
                  @click="opennews(item.id)"
                >
                  <div class="item_panel">
                    <div class="new_title">
                      {{ item.title }}
                    </div>
                    <div class="img_panel">
                      <img :src="item.img" />
                    </div>
                    <div class="date">
                      {{ item.date }}
                    </div>
                    <div class="desc">
                      {{ item.content }}
                    </div>
                  </div>
                </div>
                <div
                  v-if="index != news.length - 1"
                  class="news_item_split"
                  style="height: 50px"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="about">
        <div class="inner">
          <div class="title flex">
            <div class="flex-item">
              <span class="line"></span>
              <span style="vertical-align: middle">关于我们</span>
              <span style="vertical-align: middle" class="sub_title">/About Us</span>
            </div>
          </div>
          <!-- <div class="swiper-container"> -->
          <!-- <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="banner_item">
                  <img src="../assets/L1.jpeg" />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="banner_item">
                  <img src="../assets/L2.jpeg" />
                </div>
              </div>
            </div> -->
          <!-- 如果需要分页器 -->
          <!-- <div class="swiper-pagination"></div> -->
          <!-- 如果需要导航按钮 -->
          <!-- <div class="swiper-button-prev"></div> -->
          <!-- <div class="swiper-button-next"></div> -->
          <!-- 如果需要滚动条 -->
          <!-- <div class="swiper-scrollbar"></div> -->
          <!-- </div> -->
          <div class="flex about_panel">
            <div class="flex-item img">
              <img class="about_img" :src="this.aboutURL" />
            </div>
            <div class="flex-item about_desc">
              <div class="about_title">{{ this.name }}</div>
              <div class="about_line flex">
                <div class="about_filed">公司简介:</div>
                <div class="flex-item about_filed_value">
                  {{ this.content }}
                </div>
              </div>
              <div class="about_line flex">
                <div class="about_filed">使命愿景:</div>
                <div class="flex-item about_filed_value">
                  面向未来，
                  {{ this.vision }}始终怀揣「助力工业企业转型升级」的企业愿景，以全面深入的平台化服务覆盖转型全流程，致力于成为国内领先的数字化与自动化深度融合的全链条解决方案服务商，为中国工业数字化、智能化发展注入持续动能。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="digitize">
        <div class="inner">
          <div class="title">
            <span class="line"></span>
            <span>数字化服务</span>
            <span class="dig_title">/DIGITIZE</span>
          </div>
          <div class="pan">
            <div style="
                line-height: 28px;
                font-size: 16px;
                text-indent: 2em;
                padding-bottom: 20px;
                color: #0e0d0da9;
                padding-top: 10px;
              ">
              {{ this.vision }}
              为企业做好数字化服务，帮助企业更好的管理从供应链、生产到销售过程中的采购管理、仓储管理、工艺设计、计划排程、生产管控、质量管理、设备管理、营销管理、财务管理、决策支持等经营应用场景，进而实现企业经营管理中的数据实时性、过程可视性与协作高效性，提高企业经营效率、应变能力、决策能力，为企业降低成本与风险、构建企业核心竞争力。
            </div>
            <div style="display: flex; flex-wrap: wrap">
              <div class="dig_tit">
                <img src="../assets/jhpc.png" class="d_img" @click="digRou()" />
                <div class="d_img_wen">计划排程</div>
                <div class="d_img_con">
                  计划排程是企业生产管理过程中的重要环节，其目的是合理安排生产任务和资源配置，提高生产效率，以实现高效、有序的生产。
                </div>
              </div>
              <div class="dig_jiange"></div>
              <div class="dig_tit">
                <img src="../assets/scgl.png" class="d_img" @click="digRou()" />
                <div class="d_img_wen">生产管控</div>
                <div class="d_img_con">
                  生产管理是企业运营管理的核心部分，其目的是确保产品能够按照质量、成本和交期的要求顺利生产。
                </div>
              </div>
              <div class="dig_jiange"></div>
              <div class="dig_tit">
                <img src="../assets/zlgl.png" class="d_img" @click="digRou()" />
                <div class="d_img_wen">质量管理</div>
                <div class="d_img_con">
                  质量管理是企业在产品或服务的整个经营过程中的核心环节，主要用于确保产品或服务质量满足客户要求和相关标准。
                </div>
              </div>
              <div class="dig_jiange"></div>
              <div class="dig_tit">
                <img src="../assets/sbgl.png" class="d_img" @click="digRou()" />
                <div class="d_img_wen">设备管理</div>
                <div class="d_img_con">
                  设备管理是企业保障生产顺利进行的重要环节，其核心目标是提高设备利用率、降低故障率、延长设备寿命、保障生产连续性。
                </div>
              </div>
              <div class="dig_tit">
                <img src="../assets/yxgl.png" class="d_img" @click="digRou()" />
                <div class="d_img_wen">营销管理</div>
                <div class="d_img_con">
                  营销管理是企业经营过程中的核心职能之一，主要负责连接市场需求与生产活动，确保产品能够满足客户需求并顺利销售。
                </div>
              </div>
              <div class="dig_jiange"></div>
              <div class="dig_tit">
                <img src="../assets/cggl.png" class="d_img" @click="digRou()" />
                <div class="d_img_wen">采购管理</div>
                <div class="d_img_con">
                  采购管理是企业经营过程中的关键支持职能，主要负责获取企业所需物资、服务或外包资源，以确保生产顺利进行和成本控制。
                </div>
              </div>
              <div class="dig_jiange"></div>
              <div class="dig_tit">
                <img src="../assets/ccgl.png" class="d_img" @click="digRou()" />
                <div class="d_img_wen">仓储管理</div>
                <div class="d_img_con">
                  仓储管理是物流管理中的核心环节，通常包括以下几个主要模块，每个模块在仓储流程中承担不同的功能。
                </div>
              </div>
              <div class="dig_jiange"></div>
              <div class="dig_tit">
                <img src="../assets/jczc.png" class="d_img" @click="digRou()" />
                <div class="d_img_wen">决策支持</div>
                <div class="d_img_con">
                  决策支持是企业经营过程中的智能分析中枢，负责收集、分析和展示企业运营数据，提供可视化数据
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="direction">
        <div class="inner">
          <div class="title">
            <span class="line"></span>
            <span>服务与支持</span>
            <span class="sub_title">/DIRECTION</span>
          </div>
          <div class="pannel">
            <div class="ser-desc">
              {{
                this.vision
              }}致力于工业4.0，以智慧制作为奋斗目标，工业自动化技术为先导，加上物联网技术应用，结合大数据，云计算，人工智能等信息技术，为推动工业智能制造，产业智能升级而努力。
            </div>
            <div class="flex">
              <div class="flex-item direction_item" @click="doRouter()">
                <div class="icon">
                  <img src="../assets/zl.jpg" />
                </div>
                <div>
                  <div class="direction_title">资料下载</div>
                </div>
              </div>
              <div class="direction-item-split"></div>
              <div class="flex-item direction_item" @click="doRouter()">
                <div class="icon">
                  <img src="../assets/shouh.jpg" />
                </div>
                <div>
                  <div class="direction_title">售后服务</div>
                </div>
              </div>
              <div class="direction-item-split"></div>
              <div class="flex-item direction_item" @click="doRouter()">
                <div class="icon">
                  <img src="../assets/shenq.jpg" />
                </div>
                <div>
                  <div class="direction_title">维修申请</div>
                </div>
              </div>
              <div class="direction-item-split" @click="doRouter()"></div>
              <div class="flex-item direction_item">
                <div class="icon">
                  <img src="../assets/jishu.jpg" />
                </div>
                <div>
                  <div class="direction_title">技术支持</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="case" v-if="this.hascase">
        <div class="inner">
          <div class="title flex">
            <div class="flex-item">
              <span class="line"></span>
              <span>解决方案</span>
              <span class="sub_title">/CASE</span>
            </div>
          </div>
          <div class="ser-desc">
            以满足客户流程数字化管控+智慧物联场景建设需求为核心,帮助制造企业实现供应敏捷化、制造柔性化、产品个性化、决策智能化。
          </div>
          <div class="pannel flex">
            <div class="case_for flex line">
              <div v-for="item in cases" :key="item.id" :style="{
                width: case_forWidth / 2 - 15 + 'px',
                height: (case_forWidth - 30 * 3) / 2 - 12 + 'px',
              }" @click="doCar(item)">
                <div class="case_item_inner">
                  <div class="case_item_logo" :style="{
                    height: (case_forWidth - 30 * 3) / 2 - 72 + 'px',
                    lineHeight: (case_forWidth - 30 * 3) / 2 - 54 + 'px',
                  }">
                    <img :src="item.path" />
                  </div>
                  <div class="desc">{{ item.title }}</div>
                </div>
              </div>
            </div>
            <div class="case_car">
              <el-carousel :interval="5000" indicator-position="none" arrow="always" height="580px">
                <el-carousel-item v-for="path in this.caseItem.paths" @click="routerCasePage()"
                  style="cursor: pointer; text-align: center" :key="path">
                  <img :src="path" class="lumimg" />
                </el-carousel-item>
              </el-carousel>
              <div v-if="this.caseItem.title || this.caseItem.content" class="anli">
                <div class="anli_title">
                  <span>{{ this.caseItem.title }}</span>
                </div>
                <div class="anli_content">
                  <span> {{ this.caseItem.description }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="team">
        <div class="inner">
          <div class="title">
            <span class="line"></span>
            <span>主推品牌</span>
            <span class="sub_title">/BRAND</span>
          </div>
          <div class="pannel">
            <div class="desc">
              公司长期与西门子、施耐德、欧姆龙、三菱、明纬、ABB、松下、和泉、SMC、亚德客、魏德米勒、昆仑通态、威纶通、德力西、正泰、雷普等国内外知名电气企业保持良好的战略合作关系，共同推动技术创新和市场拓展。
            </div>
            <div class="flex line">
              <div class="flex-item team_item" @click="routerTeam">
                <div class="header">
                  <img src="//img.wds168.cn/comdata/97885/gallery/dcf5c2c6cddf8f0f5b14c4325f3a6402.jpg" />
                </div>
                <div class="team_item_desc">
                  <span>西门子</span>
                </div>
              </div>
              <div class="team_item_split"></div>
              <div class="flex-item team_item" @click="routerTeam">
                <div class="header">
                  <img src="//img.wds168.cn/comdata/97885/gallery/0ec7a3eb34e0759aba53cf296d0c2f05.jpg" />
                </div>
                <div class="team_item_desc">
                  <span>施耐德</span>
                </div>
              </div>
              <div class="team_item_split"></div>
              <div class="flex-item team_item" @click="routerTeam">
                <div class="header">
                  <img src="//img.wds168.cn/comdata/97885/gallery/8b47011a3b8972b53a9f2d11bc3939d6.jpg" />
                </div>
                <div class="team_item_desc">
                  <span>欧姆龙</span>
                </div>
              </div>
              <!-- <div class="team_item_split"></div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.swiper-container {
  width: 100%;
  height: 600px;
}

.swiper-container img {
  width: auto;
  height: 800px;
  min-width: 100%;
  /* min-height: 100%; */
}

.banner_item {
  position: relative;
  width: 100%;
  height: 97vh;
  overflow: hidden;
  padding-top: 5px;
}

.banner_item video {
  position: absolute;
  top: 50%;
  left: 50%;
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
  transform: translate(-50%, -50%);
  /**居中视频 */
  /* z-index: -1;*确保视频在内容之下 */
}

.banner_item .shouye {
  position: absolute;
  top: 54%;
  left: 50%;
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
  transform: translate(-50%, -50%);
  /**居中视频 */
  /* z-index: -1; 确保视频在内容之下 */
}

.banner_wen {
  width: 100%;
  position: absolute;
  color: aliceblue;
  top: 28%;
}

.banner_title {
  text-align: center;
  width: 100%;
  font-size: 54px;
  font-weight: 1000;
  letter-spacing: 8px;
  /*文本间隔 */
  padding-bottom: 100px;
  margin: auto;
}

.banner_content {
  padding: 10px;
  background: rgba(0, 0, 0, 0.3);
  width: 80%;
  font-size: 18px;
  font-weight: 550;
  letter-spacing: 3px;
  /*文本间隔 */
  margin: auto;
  height: 50px;
  line-height: 50px;
  text-align: center;
}

.title {
  /* height: 50px;
  line-height: 50px; */
  border-bottom: 1px solid #b5b5b5;
  padding-bottom: 2px;
}

.title .line {
  display: inline-block;
  width: 4px;
  height: 37px;
  margin-right: 15px;
  background: #3374d5;
  vertical-align: bottom;
}

.title span {
  font-size: 28px;
  font-weight: 500;
  color: #222222;
}

.title sub_title {
  font-size: 16px;
  color: #999999;
}

.news {
  background: #fff;
  padding-bottom: 25px;
}

.tabs {
  height: 60px;
  line-height: 60px;
}

.tabs .tab_item {
  height: 100%;
  width: 100px;
  text-align: center;
  font-size: 18px;
  display: inline-block;
  cursor: pointer;
}

.tabs .tab_item：hover {
  color: #f85c29;
}

.tabs .tab_item_active {
  color: #f85c29;
  border-bottom: 2px solid #f85c29;
}

.more_btn_pannel {
  width: 80px;
}

.more_btn_pannel .more_btn {
  display: inline-block;
  border: 1px solid #f85c29;
  text-align: center;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  cursor: pointer;
  width: 60px;
  color: #f85c29;
  border-radius: 30px;
}

.more_btn_pannel .more_btn:hover {
  color: #fff;
  background: #f85c29;
}

.tabitems {
  flex-wrap: wrap;
}

.new_box {
  margin-bottom: 40px;
  display: flex;
}

.news .news_item_split {
  width: 15px;
  height: 100px;
}

.news .item {
  background: #f8f8f8;
  border-radius: 3px;
  border: 2px solid #efefef;
  padding: 30px;
  cursor: pointer;
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
}

.news .item:hover {
  border: 2px solid #f85c29;
}

.news .item .new_title {
  height: 45px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
}

/* .news .item .img_panel { */
/* height: 243px; */
/* } */
.news .item img {
  /* height: 100%; */
  width: 100%;
}

.news .item .date {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #999;
}

.news .item .desc {
  line-height: 25px;
  font-size: 14px;
  color: #999;
}

.about {
  padding-top: 25px;
  background: #f8f8f8;
  margin-top: 40px;
}

.about .about_panel {
  padding-top: 50px;
  padding-bottom: 50px;
}

.about .about_panel .img {
  vertical-align: middle;
}

.about .about_panel .about_img {
  vertical-align: middle;
  width: 100%;
  height: 100%;
}

.about .about_panel .about_desc {
  padding-left: 30px;
}

.about .about_panel .about_desc .about_title {
  height: 45px;
  line-height: 45px;
  font-size: 22px;
  color: #000;
}

.about .about_panel .about_desc .about_line {
  line-height: 45px;
  vertical-align: middle;
  text-overflow: ellipsis;
}

.about .about_panel .about_desc .about_filed {
  line-height: 32px;
  width: 12%;
  color: #999;
}

.about .about_panel .about_desc .about_filed_value {
  font-size: 15px;
  letter-spacing: 3px;
  color: #000;
  line-height: 32px;
}

.direction .pannel {
  padding-top: 10px;
  padding-bottom: 60px;
}

.ser-desc {
  font-size: 17px;
  line-height: 30px;
  margin-top: 10px;
  margin-bottom: 20px;
  margin-left: 40px;
  color: #0e0d0da9;
}

.direction .pannel .icon {
  text-align: center;
}

.direction .pannel .icon img {
  width: 100%;
  height: 400px;
}

.direction .pannel .direction_title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  height: 50px;
  line-height: 50px;
}

/* .direction .pannel .direction_desc {
  text-align: center;
  font-size: 16px;
  height: 35px;
  line-height: 35px;
  color: #999;
} */
.direction .pannel .direction_item:hover {
  /* background: #88bffd75; */
  border: 2px solid #88bffd75;
  box-shadow: 0 0 10px 5px rgba(96, 166, 231, 0.712);
}

.direction .pannel .direction_item:hover .direction_title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  height: 50px;
  line-height: 50px;
  background: #1776f17c;
  color: #e9e8e8;
}

.direction .pannel .direction-item-split {
  width: 1px;
  background: #b5b5b5;
  margin: 10px;
}

.direction .pannel .direction_item {
  background: #f8f8f8;
  border-radius: 3px;
  border: 2px solid #efefef;
  cursor: pointer;
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
  padding: 10px;
  /* height: 530px; */
}

.case {
  padding-top: 25px;
  /* background: #f5f5f5; */
}

.case .pannel {
  padding-bottom: 50px;
}

.case .line {
  flex-wrap: wrap;
}

.case .case_for {
  padding-top: 5px;
  margin-left: 30px;
  width: 26%;
  justify-content: center;
  max-height: 610px;
  overflow-y: auto;
  margin-right: 20px;
}

.case .case_car {
  width: 70%;
  position: relative;
  background: rgba(0, 159, 233, 0.1);
  border: 1px solid #f8f8f8;
  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
  border-radius: 1px;
  height: 100%;
}

.case .line .case_item_split {
  width: 2px;
}

/* .case .line .case_item{

} */
.case .line .case_item_inner {
  background: #fff;
  cursor: pointer;
  border: 1px solid #f8f8f8;
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  margin-right: 10px;
  padding: 5px;
}

.case .line .case_item_inner:hover {
  box-shadow: 0 0 10px 5px rgba(248, 92, 41, 0.3);
}

.case .line .case_item_inner .case_item_logo {
  text-align: center;
  vertical-align: middle;
  align-items: center;
}

.case .line .case_item_inner .case_item_logo img {
  max-width: 100%;
  align-items: center;
  max-height: 100%;
}

.case .line .case_item_inner .desc {
  text-align: center;
  height: 40px;
  line-height: 40px;
  color: #999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.team {
  padding-top: 25px;
}

.team .pannel {
  padding-bottom: 50px;
}

.team .pannel .desc {
  line-height: 35px;
  font-size: 16px;
  text-indent: 2em;
  padding-bottom: 20px;
}

.team .pannel .line .team_item {
  background: #f8f8f8;
  border-radius: 3px;
  border: 2px solid #efefef;
  padding: 30px;
  cursor: pointer;
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
}

.team .team_item_split {
  width: 50px;
  height: 100px;
}

.team .pannel .line .team_item .header {
  text-align: center;
  vertical-align: middle;
  align-items: center;
}

.team .pannel .line .team_item .header img {
  align-items: center;
  text-align: center;
  max-width: 100%;
  width: 400px;
  height: 180px;
}

.team .pannel .line .team_item .team_item_title {
  text-align: center;
  height: 45px;
  line-height: 45px;
  font-size: 20px;
}

.team .pannel .line .team_item .team_item_desc {
  text-align: center;
  height: 35px;
  line-height: 35px;
  font-size: 18px;
  color: #816b53;
}

.dig_tit {
  width: 23.5%;
  text-align: center;
  height: 380px;
  margin-bottom: 10px;
}

.dig_jiange {
  width: 1px;
  background: #b5b5b5;
  margin: 10px;
  height: 180px;
  margin-top: 80px;
  align-items: center;
}

.d_img {
  width: 70%;
}

.dig_tit:hover .d_img {
  width: 80%;
  border-radius: 1.04vw;
  border: 0.2px solid #efefef;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
}

.d_img_wen {
  color: #3182fc;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
}

.d_img_con {
  color: gray;
  font-size: 13px;
  line-height: 20px;
  width: 80%;
  margin-left: 10%;
}

.dig_tit:hover .d_img_con {
  color: rgb(77, 169, 255);
  font-weight: 600;
}
</style>
